<template>
    <div id="about">
        <div class="about-box">
            <!-- <img src="../../../assets/image/about1.jpg" alt=""> -->
            <!-- <img src="../../../assets/image/about.jpg" alt=""> -->
            <blockquote class="main-center flex-sbw selction mtop-20" style="margin-bottom: 20px; background: #dbd7d8">
                <div class="lf-content">
                    <img class="logo1" src="../../../assets/image/about/logo1.jpg" alt="">
                    <div>
                        <h2>服务中国育儿生活<br/>传递美好育儿感动</h2>
                        <p>
                            丽家宝贝始终认为：
                            <br />养育宝宝是一个美妙而又繁琐，<br />欢乐而又严肃，<br />
                            筋疲力尽而又充满回报的过程。<br />
                            不只是妈妈一人肩负的责任，<br />
                            而应该让家庭每个成员<br />都可以积极、快乐的参与。<br />
                            我们通过为育婴者提供<br />
                            可以安心使用的优质产品，<br />
                            希望育婴者在育儿生活中，<br />
                            能露出喜悦的笑颜，<br />
                            并将这种育儿的喜悦<br/>
                            和幸福的感动传递到全社会，<br/>
                            使养育宝宝成为一件<br />
                            人人都感到幸福快乐的事情。

                        </p>
                    </div>
                </div>
                <div class="imgbox">
                    <img class="img-content" src="../../../assets/image/about/img1.jpg" alt="">
                </div>
            </blockquote>
            <blockquote class="selction" style="margin-top: 40px">
                <div class="brand-title">
                    <!-- 品牌发展BRAND DEVELOPMENT -->
                    <img class="order-img" src="../../../assets/image/about/active-1.png" alt=""/>
                </div>
                <div class="brand-content">
                    <div class="text-line">
                        <strong class="strong">【丽家宝贝】</strong>是北京丽家丽婴婴童用品股份有限公司旗下零售品牌，集团总部位于北京。公司致力于为育婴家庭提供全方位孕婴产品服务。
                    </div>
                    <div class="text-line mb-15">
                        <!-- 基础信息：<br /> -->
                        公司名称：北京丽家丽婴婴童用品股份有限公司<br />
                        简称：丽家宝贝<br />
                        外文名称：LIJIABABY INFANTS & CHILDREN SUPPLIES CO.,LTD.<br />
                        总部地点：北京市大兴区西红门镇金业大街2号<br />
                        经营范围：专业从事孕婴童产品开发及销售
                    </div>
                    <div class="color-font mb-15">
                        <strong class="strong">【丽家宝贝】</strong>建立了实体门店、线上购物商城、移动端APP等全渠道孕婴产品购物平台，满足孕婴家庭消费者从准妈妈及0-10岁宝宝的全方位需求。销售商品涵盖孕装、孕期营养品、宝宝喂哺用品、奶粉、纸尿裤、辅食、婴童装、车床椅、玩具、图书等全方面孕婴所需产品。
                        <br/>丽家宝贝始终坚持直营连锁的经营模式和区域深耕的开店策略，已创立百余家连锁直营店。
                    </div>
                    <div class="color-font mb-15">
                       <strong class="strong">【线上平台服务】</strong>丽家宝贝整合移动端服务“APP掌上旗舰店、小程序、天猫母婴商城、京东母婴商城等全渠道经营，并打造综合育儿服务体验为一体的新零售线上孕婴平台。
                    </div>
                    <div class="color-font mb-15">
                       <strong class="strong">【经营模式】</strong>以自主研发产品为核心，“电子商务+连锁专卖店”为营运依托的经营模式。
                    </div>
                    <div class="color-font mb-15">
                        <strong class="strong">旗下品牌：贝爱其味</strong>-婴幼儿辅食&全家悦享美食；<strong>爱儿可</strong>-孕婴用品，为快乐育儿提供源动力；<strong>可欧可优</strong>-为0~10岁宝宝提供服饰。
                    </div>
                    <div class="color-font mb-15">
                        <strong>贝爱其味：</strong><br/>
                        贝爱其味开发理念：丽家宝贝基于关爱孕婴家庭的健康饮食而创立贝爱其味（Bittiko）品牌，伴随孕妈妈及婴幼儿的成长需求精心开发美味、营养食品。
                        <br />贝爱其味产品涵盖：婴儿辅食品，儿童零食、家庭食品等健康美味等。
                    </div>
                    <div class="color-font mb-15">
                        <strong>爱儿可：</strong><br/>
                        爱儿可开发理念：安心温和健康！犹如天使般守护宝宝！
                        <br />爱儿可产品涵盖：母乳喂养用品、配方奶喂养用品、婴儿洗澡沐浴用品、敏感肌肤护理用品、婴幼儿专用衣物洗涤剂、防蚊虫叮咬的夏日呵护用品、纸尿裤、婴儿手推车等。
                    </div>
                     <div class="color-font mb-15">
                        <strong>可欧可优：</strong><br/>
                        可欧可优开发理念：“为我们的孩子创造属于他们的美好世界”秉承面料安全、舒适、设计简洁又新颖的设计理念，为低幼宝宝提供各类内着服，外出服及各类服饰产品。
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2003年</strong>丽家宝贝孕婴购物网站全线开通
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2004年</strong>开始开设首家小型实体母婴专卖店，北京市海淀区图书大厦店
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2006年</strong>开设中国首家一站式母婴专卖店，北京市海淀区四季青店
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2006年</strong>确定了丽家宝贝的服务定位为：服务中高端客户，全面满足育儿需求，做优质育儿生活的引导者
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2010年</strong>启动自有品牌发展计划，分别创立“爱儿可”、“可欧可优”、“贝爱其味”三个品牌
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2013年</strong>公司上线全球优质的SAP ERP管理系统，全面提升公司管理水平
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2015年</strong>新建设产品研发及仓储物流基地，为未来市场拓展奠定基础
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2016年</strong>丽家宝贝开始拓展全国连锁直营店，探索孕婴童业异地扩张的新模式
                    </div>
                    <div class="color-font">
                        <strong style="margin-right: 20px">2020年</strong>丽家宝贝全渠道营销平台系统上线，实现了线上线下全渠道数据共享及会员营运新模式。
                    </div>

                    <div class="line-icon">
                        <i class="icon-small"></i>
                        <i class="icon-big"></i>

                    </div>
                </div>

            </blockquote>

            <blockquote class="flex-sbw selction mtop-20">
                <img class="img-footer" src="../../../assets/image/about/sction2.jpg" alt="">
            </blockquote>

            <blockquote class="mtop-20">
                <div class="flex-sbw selction ">
                    <div class="lf-years">
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2019年
                            </h3>
                            <div class="mtb-38 linxing">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">2019年中童传媒最佳门店标杆奖</p>
                                <h3 class="years-h3">丽家宝贝长阳中粮万科半岛广场店荣获：</h3>
                                <p class="years-p">2019年中粮万科卓越运营团队奖</p>
                                <h3 class="years-h3">丽家宝贝宜家荟聚店荣获：</h3>
                                <p class="years-p">2019年度北京荟聚中心最佳业绩奖</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获：</h3>
                                <p class="years-p">
                                    CBME中国孕婴童年度人物<br/>
                                    CBME中国孕婴童终身成就入围奖<br />
                                    京正中国母婴产业匠心之选匠心人物奖
                                </p>
                                <div class="line-icon">
                                    <i class="icon-big"></i>
                                    <i class="icon-small"></i>
                                </div>
                            </div>
                        </div>

                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2017年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">CBME中国母婴零售商入围奖</p>
                                <p class="years-p">北京市消费者协会颁发“2016年诚信服务承诺先进单位”</p>

                                <h3 class="years-h3">丽家宝贝宜家荟聚店荣获：</h3>
                                <p class="years-p">
                                    2017年度北京荟聚中心最佳业绩奖<br/>
                                </p>
                                <h3 class="years-h3">丽家宝贝喜隆多国际购物中心店荣获:</h3>
                                <p class="years-p">
                                    2017年优秀店铺奖
                                </p>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2015年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">中国电子商务协会颁发“最具突出贡献母婴行业门户”</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获:</h3>
                                <p class="years-p">
                                    CBME中国孕婴童年度人物入围奖
                                </p>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2013年
                            </h3>
                            <div class="mtb-38 linxing">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">京正中国孕婴童最佳口碑奖</p>
                                <div class="line-icon3">
                                    <i class="line3-lf"></i>
                                    <i class="line3-rg"></i>

                                </div>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2011年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">中国孕婴童产业零售服务商综合实力百强</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获:</h3>
                                <p class="years-p">
                                    京正中国育婴童创新管理人物
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="rg-years">
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2018年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">CBME中国北区母婴零售商大奖</p>
                                <p class="years-p">北京市大兴新区金融投资商会“信用之星”称号</p>
                                <p class="years-p">北京市消费者协会颁发“2017年诚信服务承诺先进单位”</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获：</h3>
                                <p class="years-p">
                                    CBME中国孕婴童年度人物<br/>
                                    CBME中国孕婴童终身成就入围奖<br />
                                    中童传媒年度最佳行业领袖奖
                                </p>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2016年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">中国（北京）国际妇女儿童产业博览会2016年公众大拇指奖</p>
                                <p class="years-p">中国电子商务协会颁发“中国电子商务最具品牌价值奖”</p>
                                <p class="years-p">京正中国十佳母婴连锁品牌</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获：</h3>
                                <p class="years-p">
                                    CBME中国孕婴童年度人物<br/>
                                    中国妇女发展基金会颁发启爱空间公益项目--关爱使者
                                </p>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2014年
                            </h3>
                            <div class="mtb-38 linxing">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">消费者最喜爱品牌奖</p>
                                <div class="line-icon2">

                                </div>
                            </div>
                        </div>
                        <div class="margin-bottom: 20px">
                            <h3 class="title">
                                <i class="icon"></i>
                                2012年
                            </h3>
                            <div class="mtb-38">
                                <h3 class="years-h3">丽家宝贝荣获： </h3>
                                <p class="years-p">京正中国明星连锁孕婴店</p>
                                <h3 class="years-h3">丽家宝贝创始人兼CEO蒋涛女士荣获：</h3>
                                <p class="years-p">
                                    京正中国孕婴童杰出贡献人物<br/>
                                    中国玩具及婴童用品协会杰出企业家
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="selction-footer">
                    <img class="live-img" src="../../../assets/image/about/live-content.png" alt="">
                </div>
            </blockquote>
            <blockquote class="shop-box">
                <h3 class="title">门店分布</h3>
                <div class="table-header line">
                    <span class="lf">城市</span>
                    <span class="texts">店铺名称</span>
                </div>
              <div class="line">
                <span class="lf">北京海淀区（6家）</span>
                <span
                    class="rg">清河万象汇店、金源时代购物中心店、西直门枫蓝国际中心店、西三旗万象汇店、五棵松万达店、海淀大悦城店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京经济开发区（3家）</span>
                <span class="rg">大兴瀛海环宇坊店、亦庄龙湖天街店、旧宫住总万科广场店</span>
              </div>
              <div class="line">
                <span class="lf">北京朝阳区（8家）</span>
                <span class="rg">凯德MALL太阳宫店、蓝色港湾店、双井九龙汇合生创展店、长楹龙湖天街店、北京城悦荟店、东坝万达店、朝阳大悦城店、华堂新辰汇店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京通州区（4家）</span>
                <span class="rg">通州领展购物广场店、通州苏宁百货店、湾里王府井welltown店、通州爱琴海店</span>
              </div>
              <!--      <div class="line">-->
              <!--        <span class="lf">北京西城区（1家）</span>-->
              <!--        <span class="rg"></span>-->
              <!--      </div>-->
              <div class="line">
                <span class="lf">北京丰台区（4家）</span>
                <span class="rg">大红门银泰店、万丰和谐广场店、槐房万达店、凯德MALL大峡谷店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京大兴区（7家）</span>
                <span class="rg">高米店绿地店、大兴宜家荟聚中心店、大兴宜家荟聚购物中心精品店、大兴龙湖天街店、凯德MALL大兴店、大兴新辰天地店、丽家丽婴生活馆</span>
              </div>
              <div class="line">
                <span class="lf">北京昌平区（4家）</span>
                <span class="rg">昌平悦荟万科店、天通苑龙德广场店、北京超极合生汇店、昌平区平西府小站公园店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京石景山区（1家）</span>
                <span class="rg">石景山喜隆多店</span>
              </div>
              <div class="line">
                <span class="lf">北京房山区（3家）</span>
                <span class="rg">长阳绿地店、龙湖房山天街店、良乡大学城店</span>
              </div>
              <div class="table-tr line">
                <span class="lf">北京顺义区（2家）</span>
                <span class="rg">顺义中粮祥云店、北京顺义隆华购物中心店</span>
              </div>
              <!--      <div class="table-tr line">-->
              <!--        <span class="lf">北京门头沟区（1家）</span>-->
              <!--        <span class="rg"></span>-->
              <!--      </div>-->
              <div class="line">
                <span class="lf">河北（2家）</span>
                <span class="rg">燕郊永旺梦乐城店、燕郊明润广场店</span>
              </div>
            </blockquote>
            <blockquote class="flex-sbw selction mtop-20">
                <img class="img-body" src="../../../assets/image/about/img2.jpg" alt="">
                <div class="secltion3 flex-sbw " style="backround:#d2d2d4">
                    <div class="text-content">
                        <h3 class="text1">丽孕时光&nbsp;&sdot;&nbsp;丽婴生活&nbsp;&sdot;&nbsp;轻松购物</h3>
                        <h3 class="text2">注册会员领取</h3>
                        <h3 class="text3">超值优惠券大礼包</h3>
                        <img src="../../../assets/image/about/logo2.jpg" alt="">
                    </div>
                    <div class="flex-sbw wx-rg" style="padding: 0 50px 0 20px; flex: 1 1;">
                        <div class="wx-box" style="margin-right: 50px">
                            <div class="img12">
                                <img class="wximg" src="../../../assets/image/about/wx2.jpg" alt="">
                            </div>
                            <p class="text">扫描关注微信公众号</p>
                        </div>
                        <div class="wx-box">
                            <div class="img12">
                                <img class="wximg" src="../../../assets/image/about/wx1.png" alt="">
                            </div>
                            <p class="text">扫码下载APP</p>
                        </div>
                    </div>
                </div>
            </blockquote>
            <!-- <img class="img-footer" src="../../../assets/image/about2.jpg" alt=""> -->
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>

    #about{
        width: 100%;
        .mtop-20 {
            margin-top: 20px;
        }
        .mtb-38 {
            margin: 38px 0;
        }
        .linxing {
            position: relative;
        }
        .about-box{
            padding: 0 110px 30px 110px;
            .img-footer{
                width: 100%;
                height: 100%;
                // margin-top: 20px;
            }
            .main-center {
                width: 100%;
                // height: 656px;
                // background: darkcyan;

            }
            .selction {
                position: relative;
                overflow: hidden;
                .lf-content {
                    width: 28%;
                    height: 100%;
                    background: #dbd7d8;
                    padding: 0px 40px;
                    .logo1 {
                        width: 196px;
                        height: 51px;
                        display: inline-block;
                        margin: 40px 0 20px;
                    }
                    h2 {
                        font-size: 36px;
                        color: #fff;
                        margin: 10px 0 30px;
                        line-height: 51px;
                        font-family: '微软雅黑';
                        font-weight: 500;
                    }
                    p {
                        font-size: 16px;
                        color: #fff;
                        line-height: 24px;
                        font-family: "黑体 常规";
                    }


                }
                .imgbox {
                    flex: 1 0;
                    width: 63%;
                    .img-content {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }
                }
                .lf-years {
                    width: 60%;
                    // height: 600px;
                    background: #fff;
                    padding: 0 20px;
                     .line-icon {
                        position: absolute;
                        right: 34px;
                        bottom: 54px;
                        width: 147px;
                        height: 74px;
                        // background: springgreen;
                        z-index: 2;
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        justify-content: flex-end;
                        .icon-big {
                            width: 58px;
                            height: 58px;
                            background: #e4e2e5;
                            transform:rotate(46deg);
                            -ms-transform:rotate(46deg); /* Internet Explorer */
                            -moz-transform:rotate(46deg); /* Firefox */
                            -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                            -o-transform:rotate(46deg); /* Opera */
                            display: inline-block;
                            margin-right: 25px;
                            // -webkit-animation: scaleDraw 5s ease-in-out infinite;
                        }
                        .icon-small {
                            width: 25px;
                            height: 25px;
                            background: #e4e2e5;
                            transform:rotate(46deg);
                            -ms-transform:rotate(46deg); /* Internet Explorer */
                            -moz-transform:rotate(46deg); /* Firefox */
                            -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                            -o-transform:rotate(46deg); /* Opera */
                            display: inline-block;
                            // -webkit-animation: scaleDraw 5s ease-in-out infinite;
                        }
                    }
                    .line-icon3 {
                        position: absolute;
                        right: 188px;
                        bottom: 20px;
                        // background: springgreen;
                        width: 100px;
                        height: 60px;

                        .line3-lf {
                            position: absolute;
                            width: 57px;
                            height: 57px;
                            background: #eeeef0;
                            left: 0;
                            top: 0;
                            z-index: 2;
                            transform:rotate(46deg);
                            -ms-transform:rotate(46deg); /* Internet Explorer */
                            -moz-transform:rotate(46deg); /* Firefox */
                            -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                            -o-transform:rotate(46deg); /* Opera */
                            opacity: 0.9;
                        }
                        .line3-rg {
                            position: absolute;
                            width: 30px;
                            height: 30px;
                            background: #f4f4f4;
                            left: 62px;
                            top: 15px;
                            opacity: 0.9;
                            transform:rotate(46deg);
                            -ms-transform:rotate(46deg); /* Internet Explorer */
                            -moz-transform:rotate(46deg); /* Firefox */
                            -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                            -o-transform:rotate(46deg); /* Opera */
                        }
                    }

                }
                .rg-years {
                    width: 40%;
                    // height: 600px;
                    background: #fff;
                    // padding: 0 20px;
                    .line-icon2 {
                        position: absolute;
                        right: 25px;
                        bottom: 12px;
                        width: 48px;
                        height: 48px;
                        background: #e9e7ea;
                        transform:rotate(46deg);
                        -ms-transform:rotate(46deg); /* Internet Explorer */
                        -moz-transform:rotate(46deg); /* Firefox */
                        -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                        -o-transform:rotate(46deg); /* Opera */
                        display: inline-block;
                    }
                }
                .title {
                    font-size: 18px;
                    color: #908694;
                    display: flex;
                    align-items: center;
                    position: relative;
                    &::before {
                        content: '';
                        display: inline-block;
                        width: 50px;
                        height: 2px;
                        background: #908694;
                        position: absolute;
                        top: 38px;
                        left: 6px;
                    }
                    .icon {
                        width: 12px;
                        height: 12px;
                        margin-right: 6px;
                        background: #908694;
                        transform:rotate(46deg);
                        -ms-transform:rotate(46deg); /* Internet Explorer */
                        -moz-transform:rotate(46deg); /* Firefox */
                        -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                        -o-transform:rotate(46deg); /* Opera */
                        display: inline-block;
                    }
                }
                .years-h3 {
                    font-size: 16px;
                    color: #908694;
                    line-height: 24px;
                    font-weight: 600;
                    font-family: sans-serif;
                }
                .years-p {
                    font-size: 16px;
                    color: #908694;
                    line-height: 24px;
                    font-weight: 400;
                    font-family: sans-serif;

                }

                .img-body {
                    height: 258px;
                    flex: none;
                    margin-right: 20px;
                    width: 258px;
                }
                .wx-box {
                    // width: 168px;
                    text-align: center;
                    .img12 {
                        width: 168px;
                        height: 168px;
                        overflow: hidden;
                        border-radius: 6px;
                        margin-bottom: 6px;
                    }
                    img {
                        width: 100%;
                        height: 100%;
                        display: block;
                    }

                    .text {
                        font-size: 18px;
                        font-weight: 600;
                        color: #424242;
                    }
                }
            }
            .selction-footer {
                width: 100%;
                position: relative;
                height: 142px;
                background: #eae6e7;
                .live-img {
                    position: absolute;
                    right: -2px;
                    bottom: -28px;
                    z-index: 1;
                    /* width: 622px; */
                    height: 343px;
                    bottom: -13px;
                }
            }
            .flex-sbw {
                display: flex;
            }
            .flex-none {
                flex: none;
            }
            .secltion3 {
                flex: 1 1;
                background: #d2d2d4;
                height: 258px;
                justify-content: space-between;
                .text-content{
                    width: 45%;
                    // background: red;
                    padding: 30px 15px;

                    img {
                        height: 64px;
                        display: inline-block;
                    }
                    .text1 {
                        font-size: 20px;
                        font-family: inherit;
                        font-weight: 500;
                        color: #a0a0a0;
                        letter-spacing: 3px;
                    }
                    .text2 {
                        font-size: 54px;
                        font-weight: 400;
                        color: #424242;
                        font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
                        line-height: 70px;
                    }
                    .text3 {
                        color: #d44747;
                        letter-spacing: 2px;
                        font-weight: 500;
                        font-size: 36px;
                        line-height: 36px;
                    }
                }
                .wx-rg {
                    justify-content: space-around;
                    // flex: 1 1;
                    align-items: center;
                }
            }
        }
        .brand-title {
            width: 100%;
            height: 117px;
            // background: #dbd7d8;
            // font-size: 30px;
            // color: #908894;
            // line-height: 117px;
            // text-align: center;
            // font-weight: 600;
            // font-family: unset;
            .order-img {
                width: 100%;
                height: 100%;
                display: block;
            }

        }
        .brand-content {
            padding: 20px;
            position: relative;
            overflow: hidden;
            .line-icon {
                position: absolute;
                right: 128px;
                bottom: 54px;
                width: 147px;
                height: 74px;
                // background: springgreen;
                z-index: 2;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                justify-content: flex-end;
                .icon-big {
                    width: 58px;
                    height: 58px;
                    background: #e4e2e5;
                    transform:rotate(46deg);
                    -ms-transform:rotate(46deg); /* Internet Explorer */
                    -moz-transform:rotate(46deg); /* Firefox */
                    -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                    -o-transform:rotate(46deg); /* Opera */
                    display: inline-block;
                    // margin-right: 25px;
                    // -webkit-animation: scaleDraw 5s ease-in-out infinite;
                }
                .icon-small {
                    width: 25px;
                    height: 25px;
                    background: #e4e2e5;
                    transform:rotate(46deg);
                    -ms-transform:rotate(46deg); /* Internet Explorer */
                    -moz-transform:rotate(46deg); /* Firefox */
                    -webkit-transform:rotate(46deg); /* Safari 和 Chrome */
                    -o-transform:rotate(46deg); /* Opera */
                    display: inline-block;
                    margin-right: 25px;

                    // -webkit-animation: scaleDraw 5s ease-in-out infinite;
                }


            }
            .text-line {
                font-size: 16px;
                line-height: 24px;
                color: #908694;
                width: 74%;


            }
            .color-font {
                font-size: 16px;
                line-height: 24px;
                color: #908694;
            }
            .mb-15 {
                margin-bottom: 15px;
            }
            // .strong {
            //     display: inline-block;
            //     min-width: 200px;
            // }
        }

        .shop-box {
            padding-bottom: 20px;
            .title {
                text-align: center;
                height: 80px;
                line-height: 80px;
                font-size: 30px;
                color: #908794;
                margin-bottom: 15px;
                margin-top: 15px;
            }
            .table-header{
                font-size: 22px;
                background: #DBD7D8;
            }
            .table-tr {
                background: #E6E6E6;
            }
            .line {
                height: 70px;
                line-height: 70px;
                display: flex;
                align-items: center;
                color: #908794;
                padding: 10px 0;
                font-size: 16px;
                .lf {
                    width: 180px;
                    flex: none;
                    padding-left: 25px;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                }
                .rg {
                    line-height: 24px;
                    width: 80%;
                }
                .texts {
                    font-weight: 600;
                    letter-spacing: 0.5px;
                }
            }
        }
    }


</style>
